angular.module('gym.contacts').factory('ConvertToMemberService', ["$http", "$modal", "$state", "flash", "loadingAnimation", "MembershipPlans", function($http, $modal, $state, flash, loadingAnimation, MembershipPlans) {
  return {
    convert: function(contact, gym) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/gyms/contacts/confirmConvertToMemberModal.html.slim'),
        resolve: {
          contact: function() {
            return contact;
          }
        },
        controller: ["$scope", "$modalInstance", "contact", function($scope, $modalInstance, contact) {
          $scope.contact = contact;
          $scope.submit = function() {
            return $modalInstance.close();
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
      return modalInstance.result.then(function(membershipPlanId) {
        loadingAnimation.show();
        return $http.put('/convert_prospect_to_member', {
          id: contact.id,
          gym_id: gym.id()
        }).then(function() {
          flash.success = `${contact.name} converted to member`;
          loadingAnimation.hide();
          return $state.go('gym.contacts.edit', {
            contactType: 'members',
            contactId: contact.id
          });
        }, function(response) {
          loadingAnimation.hide();
          return flash.error = response.data.error;
        });
      });
    }
  };
}]);
